<a [href]="option.url" class="option" [ngClass]="font?.size" (click)="goToPage($event, option.url)" *ngFor="let option of options">
  {{ option.name | translate }}
</a>
